import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeheirLogo from '../components/SafeheirLogo';
import GlowCard, { GlowIcon } from '../components/GlowCard';

const S = '#00F5A0';
const G = '#8892A4';

const SectionLabel = ({ children }) => (
  <div style={{
    display: 'inline-flex', alignItems: 'center', gap: 8,
    color: S, fontSize: 12, fontWeight: 700,
    textTransform: 'uppercase', letterSpacing: '0.15em',
    marginBottom: 16,
  }}>
    <span style={{ width: 6, height: 6, borderRadius: '50%', background: S, display: 'inline-block', flexShrink: 0 }} />
    {children}
  </div>
);

const PrimaryBtn = ({ to, children, style: extra }) => (
  <Link to={to} style={{
    background: S, color: '#0A1628', fontWeight: 700, fontSize: 15,
    padding: '13px 30px', borderRadius: 9, textDecoration: 'none',
    display: 'inline-block', transition: 'filter 0.2s, box-shadow 0.2s',
    ...extra,
  }}
    onMouseEnter={e => { e.currentTarget.style.filter = 'brightness(1.1)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,245,160,0.45)'; }}
    onMouseLeave={e => { e.currentTarget.style.filter = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
  >{children}</Link>
);

const IconVault = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="11" width="18" height="11" rx="2" stroke={S} strokeWidth="1.5" />
    <path d="M7 11V7a5 5 0 0110 0v4" stroke={S} strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="12" cy="16" r="1.5" fill={S} />
  </svg>
);

const IconTransmit = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M5 12h14M13 6l6 6-6 6" stroke={S} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="5" cy="12" r="2" fill={S} fillOpacity="0.3" stroke={S} strokeWidth="1" />
  </svg>
);

const IconShield = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 2L4 6v6c0 5.25 3.5 10.15 8 11.35C16.5 22.15 20 17.25 20 12V6l-8-4z" stroke={S} strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M9 12l2 2 4-4" stroke={S} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Homepage = () => {
  const [waitlistEmail, setWaitlistEmail] = useState('');
  const [waitlistDone, setWaitlistDone] = useState(false);

  const handleWaitlist = (e) => {
    e.preventDefault();
    const email = waitlistEmail.trim();
    if (!email) return;
    const existing = JSON.parse(localStorage.getItem('sh_waitlist') || '[]');
    if (!existing.includes(email)) {
      existing.push(email);
      localStorage.setItem('sh_waitlist', JSON.stringify(existing));
    }
    setWaitlistDone(true);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0A1628', color: '#fff' }}>

      {/* ── 1. NAVBAR ── */}
      <header style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(10,22,40,0.9)', backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(0,245,160,0.08)',
      }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 2rem', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <SafeheirLogo size="sm" />
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Link to="/faq"
              style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: 14, fontWeight: 500, padding: '6px 12px', borderRadius: 8, transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#fff'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.6)'}
            >
              Support
            </Link>
            <Link to="/register" style={{
              background: S, color: '#0A1628', fontWeight: 700, fontSize: 14,
              padding: '8px 20px', borderRadius: 8, textDecoration: 'none',
              transition: 'filter 0.2s, box-shadow 0.2s',
            }}
              onMouseEnter={e => { e.currentTarget.style.filter = 'brightness(1.1)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,245,160,0.4)'; }}
              onMouseLeave={e => { e.currentTarget.style.filter = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              S'inscrire
            </Link>
          </div>
        </div>
      </header>

      {/* ── 2. HERO ── */}
      <section style={{ textAlign: 'center', padding: '100px 2rem 88px', maxWidth: 820, margin: '0 auto' }}>
        <h1 style={{
          fontSize: 'clamp(2rem, 5vw, 3.75rem)', fontWeight: 800,
          lineHeight: 1.15, margin: '0 0 24px', letterSpacing: '-0.02em',
        }}>
          Transmettez vos accès numériques
          <br />
          <span style={{ color: S }}>en toute sécurité</span>
        </h1>
        <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.65)', maxWidth: 560, margin: '0 auto 36px', lineHeight: 1.7 }}>
          SafeHeir centralise, protège et transmet automatiquement vos identifiants et mots de passe à vos proches en cas d'urgence ou de décès.
        </p>
        <PrimaryBtn to="/register" style={{ fontSize: 16, padding: '14px 36px', borderRadius: 10 }}>
          Commencez gratuitement
        </PrimaryBtn>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 28, flexWrap: 'wrap' }}>
          {['AES-256', 'Données en Europe', 'RGPD'].map(badge => (
            <span key={badge} style={{
              background: 'rgba(0,245,160,0.08)', border: '1px solid rgba(0,245,160,0.2)',
              borderRadius: 20, padding: '5px 14px', fontSize: 13, color: S, fontWeight: 600,
            }}>{badge}</span>
          ))}
        </div>
      </section>

      {/* ── 3. FONCTIONNALITÉS ── */}
      <section style={{ maxWidth: 1100, margin: '0 auto', padding: '80px 2rem' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <SectionLabel>Fonctionnalités</SectionLabel>
          <h2 style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.4rem)', fontWeight: 700, margin: 0, letterSpacing: '-0.02em' }}>
            Tout ce dont vous avez besoin
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24 }}>
          {[
            {
              icon: <IconVault />,
              title: 'Coffre-fort numérique',
              desc: 'Centralisez vos identifiants et mots de passe dans un espace sécurisé unique : banques, emails, réseaux sociaux, cryptomonnaies.',
              delay: '0s',
            },
            {
              icon: <IconTransmit />,
              title: 'Transmission automatique',
              desc: "Vérification mensuelle intégrée. En cas d'absence prolongée, vos bénéficiaires sont notifiés automatiquement selon vos instructions.",
              delay: '0.2s',
            },
            {
              icon: <IconShield />,
              title: 'Sécurité maximale',
              desc: "Architecture conçue pour l'hébergement européen. Vos données restent sous votre contrôle, protégées par mot de passe.",
              delay: '0.4s',
            },
          ].map(({ icon, title, desc, delay }) => (
            <GlowCard key={title} delay={delay} style={{ padding: '28px 24px' }}>
              <div style={{
                width: 48, height: 48, borderRadius: 12, marginBottom: 20,
                background: 'rgba(0,245,160,0.08)', border: '1px solid rgba(0,245,160,0.2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 0 12px rgba(0,245,160,0.2)',
              }}>
                <GlowIcon delay={delay}>{icon}</GlowIcon>
              </div>
              <h3 style={{ fontSize: 17, fontWeight: 700, margin: '0 0 10px' }}>{title}</h3>
              <p style={{ fontSize: 14, color: G, lineHeight: 1.65, margin: 0 }}>{desc}</p>
            </GlowCard>
          ))}
        </div>
      </section>

      {/* ── 4. COMMENT ÇA MARCHE ── */}
      <section style={{ maxWidth: 1100, margin: '0 auto', padding: '0 2rem 80px' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <SectionLabel>Comment ça marche</SectionLabel>
          <h2 style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.4rem)', fontWeight: 700, margin: 0, letterSpacing: '-0.02em' }}>
            En trois étapes simples
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24 }}>
          {[
            {
              num: '01',
              title: 'Créez votre compte',
              desc: 'Inscription en 2 minutes. Vos données sont chiffrées de bout en bout — jamais accessibles à SafeHeir.',
            },
            {
              num: '02',
              title: 'Désignez vos successeurs',
              desc: 'Ajoutez vos bénéficiaires de confiance avec leurs coordonnées. Précisez qui reçoit quoi et dans quelles circonstances.',
            },
            {
              num: '03',
              title: 'Le check-in mensuel vous protège',
              desc: 'Confirmez votre présence chaque mois. Sans réponse, vos bénéficiaires sont avertis selon votre plan.',
            },
          ].map(({ num, title, desc }, i) => (
            <GlowCard key={num} delay={`${i * 0.15}s`} style={{ padding: '28px 24px' }}>
              <div style={{
                fontSize: 40, fontWeight: 800, color: S, opacity: 0.22,
                lineHeight: 1, marginBottom: 18, fontVariantNumeric: 'tabular-nums',
              }}>{num}</div>
              <h3 style={{ fontSize: 17, fontWeight: 700, margin: '0 0 10px' }}>{title}</h3>
              <p style={{ fontSize: 14, color: G, lineHeight: 1.65, margin: 0 }}>{desc}</p>
            </GlowCard>
          ))}
        </div>
      </section>

      {/* ── 5. LE PROBLÈME ── */}
      <section style={{ maxWidth: 1100, margin: '0 auto', padding: '0 2rem 80px' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <SectionLabel>Le problème</SectionLabel>
          <h2 style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.4rem)', fontWeight: 700, margin: 0, letterSpacing: '-0.02em' }}>
            Un problème urgent et méconnu
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24 }}>
          {[
            { value: '+150', label: 'comptes numériques moyens par personne' },
            { value: '88%', label: 'des comptes restent inaccessibles après un décès' },
            { value: '400M€', label: 'de bénéficiaires bloqués à la Caisse des Dépôts en France' },
          ].map(({ value, label }) => (
            <GlowCard key={value} style={{ padding: '40px 24px', textAlign: 'center' }}>
              <div style={{
                fontSize: 48, fontWeight: 700, color: S, lineHeight: 1, marginBottom: 14,
                textShadow: '0 0 20px rgba(0,245,160,0.4)',
              }}>{value}</div>
              <p style={{ fontSize: 14, color: G, lineHeight: 1.6, margin: 0 }}>{label}</p>
            </GlowCard>
          ))}
        </div>
        <p style={{ textAlign: 'center', fontSize: 11, color: 'rgba(255,255,255,0.2)', marginTop: 24, margin: '24px 0 0' }}>
          * Estimations basées sur des études sectorielles 2023–2024 (Dashlane, Google, Caisse des Dépôts).
        </p>
      </section>

      {/* ── 6. CTA FINAL ── */}
      <section style={{ maxWidth: 800, margin: '0 auto', padding: '0 2rem 80px' }}>
        <GlowCard style={{ padding: '56px 40px', textAlign: 'center' }}>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.2rem)', fontWeight: 700, margin: '0 0 16px', letterSpacing: '-0.02em' }}>
            Protégez votre patrimoine numérique dès aujourd'hui
          </h2>
          <p style={{ fontSize: 16, color: G, maxWidth: 440, margin: '0 auto 36px', lineHeight: 1.65 }}>
            Rejoignez les familles qui ont sécurisé leur transmission numérique
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <PrimaryBtn to="/register">Essai gratuit de 30 jours →</PrimaryBtn>
            <Link to="/login" style={{
              background: 'transparent', color: '#fff', fontWeight: 600, fontSize: 15,
              padding: '13px 30px', borderRadius: 9, textDecoration: 'none',
              display: 'inline-block', border: '1px solid rgba(255,255,255,0.2)',
              transition: 'border-color 0.2s, background 0.2s',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(0,245,160,0.4)'; e.currentTarget.style.background = 'rgba(0,245,160,0.05)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; e.currentTarget.style.background = 'transparent'; }}
            >
              Voir la démo
            </Link>
          </div>
        </GlowCard>
      </section>

      {/* ── 7. LISTE D'ATTENTE ── */}
      <section style={{ maxWidth: 640, margin: '0 auto', padding: '0 2rem 96px' }}>
        <GlowCard style={{ padding: '44px 40px', textAlign: 'center' }}>
          <SectionLabel>Accès</SectionLabel>
          <h2 style={{ fontSize: '1.8rem', fontWeight: 700, margin: '0 0 10px', letterSpacing: '-0.02em' }}>
            Rejoignez la liste d'attente
          </h2>
          <p style={{ fontSize: 15, color: G, margin: '0 0 28px', lineHeight: 1.65 }}>
            Soyez parmi les premiers à accéder à SafeHeir
          </p>
          {waitlistDone ? (
            <div style={{
              background: 'rgba(0,245,160,0.08)', border: '1px solid rgba(0,245,160,0.25)',
              borderRadius: 10, padding: '16px 20px', color: S, fontWeight: 600, fontSize: 15,
            }}>
              ✓ Vous êtes sur la liste !
              <div style={{ color: G, fontWeight: 400, fontSize: 13, marginTop: 4 }}>
                On vous contacte dès l'ouverture.
              </div>
            </div>
          ) : (
            <form onSubmit={handleWaitlist} style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
              <input
                type="email"
                required
                value={waitlistEmail}
                onChange={e => setWaitlistEmail(e.target.value)}
                placeholder="votre@email.com"
                style={{
                  flex: '1 1 200px', minWidth: 0,
                  background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: 8, padding: '11px 14px', color: '#fff', fontSize: 14, outline: 'none',
                }}
              />
              <button type="submit" style={{
                background: S, color: '#0A1628', fontWeight: 700, fontSize: 14,
                padding: '11px 24px', borderRadius: 8, border: 'none', cursor: 'pointer',
                flexShrink: 0, transition: 'filter 0.2s',
              }}
                onMouseEnter={e => e.currentTarget.style.filter = 'brightness(1.1)'}
                onMouseLeave={e => e.currentTarget.style.filter = 'none'}
              >
                S'inscrire
              </button>
            </form>
          )}
        </GlowCard>
      </section>

      {/* ── 8. FOOTER ── */}
      <footer style={{
        borderTop: '1px solid rgba(255,255,255,0.06)',
        padding: '40px 2rem 32px',
        background: 'rgba(5,11,26,0.7)',
      }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
            <SafeheirLogo size="sm" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', flexWrap: 'wrap', marginBottom: 14 }}>
            {[
              { label: 'Politique de confidentialité', to: '/legal/confidentialite' },
              { label: 'CGU', to: '/legal/cgu' },
              { label: 'Mentions légales', to: '/legal/mentions-legales' },
              { label: 'FAQ', to: '/faq' },
            ].map(({ label, to }) => (
              <Link key={to} to={to}
                style={{ color: 'rgba(255,255,255,0.4)', textDecoration: 'none', fontSize: 13, transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = S}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.4)'}
              >{label}</Link>
            ))}
            <a href="mailto:contact@safeheir.fr"
              style={{ color: 'rgba(255,255,255,0.4)', textDecoration: 'none', fontSize: 13, transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = S}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.4)'}
            >Contact</a>
          </div>
          <p style={{ margin: '0 0 4px', fontSize: 12, color: 'rgba(255,255,255,0.2)' }}>
            Chiffrement de bout en bout · Hébergement européen RGPD-compliant
          </p>
          <p style={{ margin: 0, fontSize: 12, color: 'rgba(255,255,255,0.3)' }}>
            © 2026 SafeHeir. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Homepage;
